import axios from "axios";
// import toast from "react-hot-toast";
import { config } from "../../Utils/helpers";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const GetUserAppointmentList = (listData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "USER_APPOINTMENT_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/appointment/user-appointment-list`,
        listData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "USER_APPOINTMENT_LIST_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "USER_APPOINTMENT_LIST_FAIL",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "USER_APPOINTMENT_LIST_FAIL",
        payload: error?.response,
      });
    }
  };
};


export const GetUserAppointmentPaymentList = (listData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "USER_APPOINTMENT_PAYMENT_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/vr-home-visit/payments`,
        listData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "USER_APPOINTMENT_PAYMENT_LIST_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "USER_APPOINTMENT_PAYMENT_LIST_FAIL",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "USER_APPOINTMENT_PAYMENT_LIST_FAIL",
        payload: error?.response,
      });
    }
  };
};

export const ViewUserAppointment = (appointmentId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "USER_APPOINTMENT_VIEW_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/appointment/user-appointment-view/${appointmentId}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "USER_APPOINTMENT_VIEW_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "USER_APPOINTMENT_VIEW_FAIL",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "USER_APPOINTMENT_VIEW_FAIL",
        payload: error?.response?.data?.message,
      });
    }
  };
};
